import React from "react";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useWhitelabel } from "../../contexts/WhitelabelContext";

const InvalidToken = () => {
  const { backgroundColor, fontColor } = useWhitelabel();
  return (
    <React.Fragment>
      <Helmet title="Invalid Token" />
      <div className="text-center">
        <h1 className="display-1 fw-bold">Invalid Token</h1>
        <p className="h1">Your access link is no longer valid.</p>
        <p className="h2 fw-normal mt-3 mb-4">
          The token you used is either expired, malformed, or has already been
          used.
        </p>
        <Link to="/auth/sign-in">
          <Button
            variant="primary"
            size="lg"
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
            }}
          >
            Return to Homepage
          </Button>
        </Link>
      </div>
    </React.Fragment>
  );
};

export default InvalidToken;
